<template>
  <v-container grid-list-xs>
    <!-- decidindo qual versão da apuração exibir -->
    <div v-if="carregando" class="d-flex justify-center py-8">
      <v-progress-circular indeterminate color="primary" />
    </div>

    <template v-else>
      <!-- Campanhas antigas: dados na tabela antiga -->
      <template v-if="modo === 'antiga'">
        <SectionCardsResumoLegacy />
        <SectionListColaboradorCampanhaFuncao />
      </template>

      <!-- Campanhas novas (padrão): dados na apuração nova -->
      <template v-else>
        <SectionCardsResumo :items-apuracao="apuracaoItems" />
        <SectionApuracao :items-apuracao="apuracaoItems" />
      </template>

      <SectionRelatorios :items-apuracao="apuracaoItems" />
      <FilterApuracaoCards
        v-if="getCampanha.id_tipo_dado === 'C'"
        :mesAnoCampanha="{
          mes_ref: getCampanha.mes_ref,
          ano_ref: getCampanha.ano_ref
        }"
      />
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import http from "@/services/http";
import FilterApuracaoCards from "@/components/campanha/apuracao/FilterApuracaoCards.vue";
import SectionApuracao from "@/components/campanha/apuracao/SectionApuracao.vue";

export default {
  name: "DetalhesCampanha",

  components: {
    FilterApuracaoCards,
    SectionApuracao,
    SectionCardsResumo: () =>
      import("@/components/campanha/apuracao/SectionCardsResumo"),
    SectionCardsResumoLegacy: () =>
      import("@/components/campanha/apuracao/SectionCardsResumoLegacy"),
    SectionListColaboradorCampanhaFuncao: () =>
      import(
        "@/components/campanha/apuracao/SectionListColaboradorCampanhaFuncao"
      ),
    SectionRelatorios: () =>
      import("@/components/campanha/apuracao/SectionRelatorios")
  },

  data() {
    return {
      // "nova" ou "antiga"; começa em "nova" como padrão
      modo: "nova",
      carregando: true,
      apuracaoItems: []
    };
  },

  computed: {
    ...mapGetters({
      getCampanha: "campanha/getCampanha",
      getApuracao: "campanha/getApuracao"
    })
  },

  methods: {
    ...mapActions({
      actionCampanha: "campanha/actionCampanha",
      actionApuracaoColaboradorCampanha:
        "campanha/actionApuracaoColaboradorCampanha"
    }),

    // Decide entre apuração nova e antiga pela presença de dados:
    // 1) se a apuração nova retornar linhas -> versão nova;
    // 2) senão, se a apuração antiga tiver linhas -> versão antiga;
    // 3) senão (campanha ainda sem apuração) -> versão nova (padrão).
    async decidirModo(idCampanha) {
      this.carregando = true;
      try {
        const { data } = await http.get("/campanhas/apuracao-campanha", {
          params: { id_campanha: idCampanha, per_page: -1 }
        });
        const novos = Array.isArray(data) ? data : data.data || [];

        if (novos.length > 0) {
          this.apuracaoItems = novos;
          this.modo = "nova";
          return;
        }

        // Sem dados na apuração nova: tenta a antiga
        try {
          await this.actionApuracaoColaboradorCampanha({
            id_campanha: idCampanha
          });
        } catch (e) {
          // endpoint antigo indisponível/erro -> mantém padrão novo
        }

        const antigos = this.getApuracao?.itemsColaboradorCampanha || [];
        this.modo = antigos.length > 0 ? "antiga" : "nova";
      } catch (e) {
        this.modo = "nova";
      } finally {
        this.carregando = false;
      }
    }
  },

  async mounted() {
    const idCampanha = this.$route.params.idCampanha;
    this.actionCampanha(idCampanha);
    await this.decidirModo(idCampanha);
  }
};
</script>

<style></style>
